/**
 * @desc Demo Navigation List Data
 */
export const navbarList = [
  {
    path: '/about-us',
    title: 'About us',
    detailTabs: []
  },
  {
    path: '/how-it-works',
    title: 'How it works',
    detailTabs: []
  },
  {
    path: '/new',
    title: 'New',
    detailTabs: []
  },
  {
    path: '/view',
    title: 'View All',
    detailTabs: []
  }
  // {
  //   path: '/search/children',
  //   title: 'Children',
  //   detailTabs: []
  // },
  // {
  //   path: '/search/patients',
  //   title: 'Patients',
  //   detailTabs: []
  // },
  // {
  //   path: '/search/pets',
  //   title: 'Pets',
  //   detailTabs: []
  // },
  // {
  //   path: '/search/disaster',
  //   title: 'Disaster',
  //   detailTabs: []
  // },
  // {
  //   path: '/search/other-thing',
  //   title: 'Others',
  //   detailTabs: []
  // }
]
